// extracted by mini-css-extract-plugin
module.exports = {"buttons":"StandardFormButtons_buttons__1DNt5","compact":"StandardFormButtons_compact__3nAth","pulse":"StandardFormButtons_pulse__34n0W"};